import { Auth } from "aws-amplify";


export const CognitoData = async()=>{
    const user1 = await Auth.currentSession();
    return user1;
}

export const CognitoCurrentData = async()=>{
    const user1 =  await Auth.currentAuthenticatedUser({bypassCache: true});
    return user1.attributes;
}

export const getCurrentUserSession = async () => {
    try {
        const session = await Auth.currentSession();
        return session;
    } catch (error) {
        return null;
    }
};



const getUserAttributes = async () => {
    try {
        const session = await getCurrentUserSession();
        if (session) {
            const userAttributes = session.getIdToken().payload;
            return userAttributes;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
};
  